import { render, staticRenderFns } from "./ListOrganizations.vue?vue&type=template&id=dd1b3b90&scoped=true&"
import script from "./ListOrganizations.vue?vue&type=script&lang=js&"
export * from "./ListOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1b3b90",
  null
  
)

export default component.exports